import leadReferalApi from '@src/features/leads/services/lead-referal-api';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipLeadReferalValue = ({ id }: ChipValueRendererProps) => {
  const { data: status } = leadReferalApi.useFetchOne({ id });

  return <>{status?.name}</>;
};
